// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "popupHeader-36iY8";
var _3 = "paper-271O_";
var _4 = "dialog__header-3OLXC";
var _5 = "header-3S9u-";
export { _1 as "__esModule", _2 as "popupHeader", _3 as "paper", _4 as "dialog__header", _5 as "header" }
export default { "__esModule": _1, "popupHeader": _2, "paper": _3, "dialog__header": _4, "header": _5 }
